import React from 'react'

import {
  RequireLabel,
  RequireToggle,
  useRequireConfigField,
} from 'components/RequireConfig'

const RequireFieldLabel = ({
  children,
  configurable = true,
  disabled = false,
  fieldAliases = [],
  fieldKey,
  label,
  readOnly = false,
  type = '',
  value,
  visible = true,
}) => {
  const requireField = useRequireConfigField({
    configurable,
    disabled,
    fieldAliases,
    fieldKey,
    label,
    readOnly,
    type,
    value,
    visible,
  })

  return (
    <span className="d-flex align-items-center">
      <RequireToggle field={requireField} />
      <span>
        <RequireLabel required={requireField.required}>
          {children || label}
        </RequireLabel>
      </span>
    </span>
  )
}

export default RequireFieldLabel
